import { mxConstants, mxGeometry } from 'mxgraph-js';
import FaultTreeVertex from '../FaultTreeVertex';
import HouseEventVertexValue from './HouseEventVertexValue';
import ReferenceTypes from '../../HCLTreeVertexValue/ReferenceTypes';
import HCLTreeVertex from '../../HCLTreeVertex';
import HouseEventVertexDefaultShape from '../../../HCLCellShape/FaultTree/HouseEvent/HouseEventVertexDefaultShape';
import HouseEventVertexDetailedShape from "../../../HCLCellShape/FaultTree/HouseEvent/HouseEventVertexDetailedShape";

class HouseEventVertex extends FaultTreeVertex {
  constructor(key: string, value: HouseEventVertexValue) {
    super(key, value, ReferenceTypes.HOUSE_EVENTS);
  }

  getMyGeometry() {
    return new mxGeometry(0, 0, HouseEventVertex.SHAPE.WIDTH, HouseEventVertex.SHAPE.HEIGHT);
  }

  getType(): string {
    return 'House Event';
  }

  getMyStyle() {
    const style: {[index: string]: any} = {};
    style[mxConstants.STYLE_SPACING] = 6;
    style[mxConstants.STYLE_FILLCOLOR] = 'rgba(222,130,125,0.2)';
    style[mxConstants.STYLE_STROKECOLOR] = 'rgba(140,84,46,0.65)';
    style[mxConstants.STYLE_FILL_OPACITY] = '100';
    style[mxConstants.STYLE_STROKE_OPACITY] = '100';
    style[mxConstants.STYLE_STROKEWIDTH] = '2';
    style[mxConstants.STYLE_FONTCOLOR] = 'inherit';
    style[mxConstants.STYLE_FONTSIZE] = '12';
    style[mxConstants.STYLE_FONTFAMILY] = 'Roboto Condensed';
    style[mxConstants.STYLE_WHITE_SPACE] = 'wrap';
    style[mxConstants.STYLE_AUTOSIZE] = 1;
    style[mxConstants.STYLE_RESIZABLE] = 0;
    style[mxConstants.STYLE_ASPECT] = 'fixed';
    style[mxConstants.STYLE_OVERFLOW] = 'hidden';
    return style;
  }

  public updateShape(isSubLabelVisible: boolean): void {
    const style = this.getMyStyle();
    if (isSubLabelVisible) {
      style[mxConstants.STYLE_SHAPE] = HouseEventVertexDetailedShape.typeString;
      style[mxConstants.STYLE_SPACING_BOTTOM] = HouseEventVertex.SHAPE.GATE + HouseEventVertexDetailedShape.SUB_LABEL_HEIGHT;
    } else {
      style[mxConstants.STYLE_SHAPE] = HouseEventVertexDefaultShape.typeString;
      style[mxConstants.STYLE_SPACING_BOTTOM] = HouseEventVertex.SHAPE.GATE;
    }
    this.setStyle(HCLTreeVertex.mapStyles(style));
  }

  clone(): HouseEventVertex {
    return new HouseEventVertex(null, this.value.clone());
  }
}

export default HouseEventVertex;
